const getCurrentToast = state => state.currentToast;

const getGlobalToastVisibility = state => state.isGlobalToastVisible;

export default {
  getCurrentToast,
  getGlobalToastVisibility
};



// WEBPACK FOOTER //
// ./src/store/modules/toasts/getters.js